import * as React from "react";
const SvgDot = (props) => /* @__PURE__ */ React.createElement("svg", { width: 4, height: 4, viewBox: "0 0 4 4", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: 1.70483, cy: 2.19873, r: 1.26636, fill: "currentColor" }));
export default SvgDot;
